var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('sarala-table',{ref:"table",attrs:{"model":_vm.model,"resourceName":_vm.$tc('resources.user.name', 1),"createRoute":{ name: 'user.create' }},scopedSlots:_vm._u([{key:"action",fn:function({ item }){return [_c('edit-btn',{attrs:{"to":{
                        name: 'user.edit',
                        params: { id: item.id },
                    }}}),_c('delete-btn',{attrs:{"disabled":item.id == 1},on:{"click":function($event){return _vm.deleteItem(item)}}})]}}])})],1),_c('confirm-delete',{ref:"confirmDelete"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }